export default "__VITE_ASSET__D0T4sO9E__"